module.exports = __webpack_public_path__ + "static/media/revisePassword.619cbc1c.png";